import apiV3 from "../utils/apiV3";

interface ILoginResponse {
    status: string,
    user: number,
    token: string,
}

async function doPostLogin(email:string, password:string):Promise<ILoginResponse | undefined> {
    let response = await apiV3.postEncoded('envimpact/login', {email, password});
    if (response) return response.data;
    else return undefined;
}

async function doGetWhoAmI() {
    let response = await apiV3.get('envimpact/whoami');
    if (response) return response.data;
}

export {
    doPostLogin,
    doGetWhoAmI,
}
